export const FETCH_AVAILABILITY = 'v1/availability/FETCH_AVAILABILITY';

export type FetchAvailabilityPending = {meta: any};
export type FetchAvailabilitySuccess = {
  data: any;
  meta: any;
};
export type FetchAvailabilityError = {error?: unknown; meta: any};
